import AdminOperationsScreen from "../src/features/arrangements/screens/AdminOperationsScreen";

export default function AccountScreen() {
  return <AdminOperationsScreen screenIdOverride="staff-profile" />;
}
